import React from 'react';
import { CTAButton } from './CTAButton';
import { CustomAudioPlayer } from './CustomAudioPlayer';
interface HeroSectionProps {
  onCTAClick: () => void;
  audioUrl?: string;
}
export function HeroSection({
  onCTAClick,
  audioUrl
}: HeroSectionProps) {
  const scrollToPrice = () => {
    const priceSection = document.getElementById('price-section');
    if (priceSection) {
      priceSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" style={{
    backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/w23bsmVYsXg2Fcm6NkCPMx/WhatsApp_Image_2025-11-23_at_1.13.04_AM.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }} data-id="element-73">
      {/* Soft gradient overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#1C2A3A]/40 via-[#1C2A3A]/30 to-[#1C2A3A]/50" data-id="element-74" />

      {/* Content - Centered with comfortable spacing */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 py-24 text-center" data-id="element-75">
        {/* Audio Player - Top Priority */}
        <div className="mb-12" data-id="element-76">
          <p className="text-[#FBF9F6] text-sm font-medium mb-4 tracking-wide" data-id="element-77">
            🎧 Listen to an audiobook excerpt
          </p>
          <CustomAudioPlayer audioUrl={audioUrl || 'https://files.catbox.moe/ii497t.m4a'} data-id="element-78" />

          {/* Additional Audio Info */}
          <div className="mt-6 max-w-3xl mx-auto" data-id="element-79">
            <p className="text-[#FBF9F6]/95 text-base md:text-lg leading-relaxed" style={{
            textShadow: '0 2px 12px rgba(28, 42, 58, 0.5)'
          }} data-id="element-80">
              Listen wherever you want. In the car, at the gym, while cooking or
              going for a walk. Every minute becomes an opportunity to
              understand your anxiety, master it, and use it to your advantage.
              You don't need extra time: just press play and let your day work
              for you.
            </p>
          </div>
        </div>

        {/* Hero Title - Soft, elegant typography */}
        <h1 className="font-['Crimson_Text'] text-4xl md:text-6xl lg:text-7xl font-semibold text-[#FBF9F6] mb-8 leading-tight" style={{
        textShadow: '0 4px 20px rgba(28, 42, 58, 0.6)'
      }} data-id="element-81">
          What if your anxiety wasn't your enemy... but your teacher?
        </h1>

        {/* Hero Subtitle - Warm, inviting */}
        <p className="text-lg md:text-xl lg:text-2xl text-[#FBF9F6]/95 mb-12 leading-relaxed max-w-3xl mx-auto" style={{
        textShadow: '0 2px 12px rgba(28, 42, 58, 0.5)'
      }} data-id="element-82">
          What if what you fear so much—that pressure in your chest, those
          thoughts that won't stop—didn't come to punish you, but to awaken you?
        </p>

        {/* CTA Button - Warm ochre */}
        <div className="mb-8" data-id="element-83">
          <CTAButton size="large" onClick={scrollToPrice} data-id="element-84">
            Download the eBook now for $24.99
          </CTAButton>
        </div>

        {/* Trust Badge - Soft and reassuring */}
        <p className="text-[#FBF9F6]/90 text-sm font-light tracking-wide" style={{
        textShadow: '0 2px 8px rgba(28, 42, 58, 0.4)'
      }} data-id="element-85">
          ✓ 30-day guarantee • ✓ Instant download • ✓ 3 bonuses included
        </p>
      </div>
    </section>;
}